import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  palette: {
    action: {
      disabled: 'transparent',
      disabledBackground: 'transparent',
    },
    primary: {
      main: '#39e956',
      contrastText: '#ffffff',
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        width: '104px',
      },
    },
  },
  shadows: [
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
  ],
});
